const isValidUrl = (url) => {
  const domain = /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i;
  const ipPattern =
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?::[1-9][0-9]{0,4})?$/;

  try {
    const urlObj = new URL(url);
    const { host, hostname } = urlObj;

    // This prevents decimal IP conversion (e.g., 1111 -> 0.0.4.87)
    const originalHostname = url
      .replace(/^https?:\/\//, '')
      .split('/')[0]
      .split(':')[0]
      .toLowerCase();

    if (originalHostname !== hostname) return false;
    if (host.length > 253) return false;
    if (ipPattern.test(hostname)) return true;

    return domain.test(hostname);
  } catch (_) {
    return false;
  }
};

const isURL = (str) => {
  const trimmedStr = str.trim();

  if (trimmedStr.includes(' ') || trimmedStr.includes('..')) {
    return false;
  }

  if (
    trimmedStr.toLowerCase().startsWith('http://') ||
    trimmedStr.toLowerCase().startsWith('https://')
  ) {
    return isValidUrl(trimmedStr);
  }

  if (trimmedStr.startsWith('//')) {
    return isValidUrl(`https:${trimmedStr}`);
  }

  return isValidUrl(`https://${trimmedStr}`);
};

export default isURL;
